import React from 'react';
import { CtaButton } from './CtaButton';
const comparisons = [{
  amount: 'USD 500 – 2,000',
  label: 'lo que gastarás en un dron: sin conocimiento, dinero desperdiciado'
}, {
  amount: 'USD 1,000 – 3,000',
  label: 'el costo de un curso presencial en tu ciudad'
}, {
  amount: 'USD 500 – 10,000',
  label: 'la multa si vuelas sin saber las leyes'
}];
export function FinalCta() {
  return <section className="w-full bg-ink-900 py-20 text-white lg:py-28" aria-labelledby="final-cta-heading" data-id="element-93" data-mp="1jcvce3tr00zr">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-94" data-mp="1eek3bvba1uil">
        <h2 id="final-cta-heading" className="text-3xl font-black leading-tight tracking-tight sm:text-5xl" data-id="element-95" data-mp="1ebxttq4tt4xq">
          Tu momento es ahora. No mañana.
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-white/70" data-id="element-96" data-mp="1o56ad14xhcpo">
          No necesitas ser ingeniero ni tener experiencia previa: solo empezar correctamente desde el
          inicio.{' '}
          <strong className="font-bold text-white" data-id="element-97" data-mp="1x5kwu3tmoxur">
            Drone Commander es tu mapa. El resto depende de ti.
          </strong>
        </p>
      </div>

      <div className="mx-auto mt-12 grid max-w-content gap-4 px-6 sm:grid-cols-3" data-id="element-98" data-mp="s4pe1ueleodj">
        {comparisons.map(item => <div key={item.amount} className="rounded-lg border border-white/10 bg-ink-800 p-6 text-center" data-id="element-99" data-mp="x41wm2yfl9ab">
            <p className="text-xl font-black tracking-tight text-white" data-id="element-100" data-mp="123ek8px4mkdy">{item.amount}</p>
            <p className="mt-2 text-sm leading-snug text-white/55" data-id="element-101" data-mp="164qbt0zk9fos">{item.label}</p>
          </div>)}
      </div>

      <div className="mx-auto mt-12 max-w-3xl px-6 text-center" data-id="element-102" data-mp="1b31l9aly1o6h">
        <p className="text-xl font-semibold leading-snug text-white" data-id="element-103" data-mp="1b170pxel3y2x">
          La pregunta es simple: ¿compras la guía correcta hoy, o pierdes dinero mañana?
        </p>
        <div className="mt-8" data-id="element-104" data-mp="1kstkii4zn5ha">
          <CtaButton label="Sí, quiero empezar Drone Commander" size="lg" href="https://pay.hotmart.com/W107708315Q?checkoutMode=10" data-id="element-105" data-mp="1kv7cgi4dg1km" />
        </div>
        <p className="mt-4 text-xs text-white/50" data-id="element-106" data-mp="1tv2rwz4ymiqg">
          Garantía de 7 días. Acceso inmediato. Sin preguntas.
        </p>
      </div>
    </section>;
}